module.exports = __webpack_public_path__ + "img/fourday_ps_22.051bcdac.jpg";